import { useEffect } from 'react';
import '../../Technology.css'
import TechItem from '../../common/TechItem';

const Localis = () => {

    useEffect(() => {
        document.title = 'Séneca patrocinará el I Congreso Red Localis'
        window.scrollTo(0, 0)
    }, []);

    return (

        <TechItem
            title={'Séneca patrocinará el I Congreso Red Localis'}
            imageURL={'/images/technology/tecnologia-5.jpg'}
            date={'22 mayo, 2017'}
            textArray={[
                "<p className='middle-section-label'>Spica sigue apostando por la transparencia y la innovación tecnológica en las administraciones a través de su software Séneca. Por ello, estaremos presentes como colaboradores en el I Congreso Red Localis, que se celebrará en el Centro Cultural Marcos Valcarcel (Ourense) los días 20 y 21 de junio de 2017, cuyo tema central será ‘Las entidades locales ante la transparencia y la innovación’.</p>",
                "<p className='middle-section-label'>Durante dos días, Ourense contará con la presencia de destacados expertos del mundo académico y profesionales en activo del mundo local de toda España. El congreso contará con cuatro paneles y sus correspondientes ponentes expertos del mundo académico y profesional. También se celebrará una sesión especial en la que participarán representantes políticos y los medios de comunicación, relacionados todos con el sector público local.</p>",
                "<p className='middle-section-label'>El congreso se organizará en cuatro ejes:</p>",
                "<ol className='middle-section-label ml-50'><li>Compra pública y colaboración público-privada.</li><li>Transparencia, buen gobierno y participación ciudadana.</li><li>Administración electrónica para la eficiencia y la economía.</li><li>Calidad en los servicios públicos de ámbito local.</li></ol>",
                "<img loading='lazy' alt='Imagen' src='/images/technology/localis.jpg' className='technology-logo'></img>"
            ]}
        />

    )

}

export default Localis